import { render } from "./AuthPage.vue?vue&type=template&id=3ab3dffa&scoped=true"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=3ab3dffa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab3dffa"]])

export default __exports__